module.exports = __webpack_public_path__ + "static/media/Civil Structure Alignments in Revit.1cb7f9d0.png";